"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Alert-card colours live in tamagui-config (`ALERT_SEVERITY_COLORS`).
